var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center","margin-top":"200px"}},[_c('h1',{staticStyle:{"font-size":"30px"}},[_vm._v("尊贵的管理员，欢迎回来!")])])
}]

export { render, staticRenderFns }